import { Component, Input, OnInit, Self } from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NgControl } from '@angular/forms';
import { noop } from 'rxjs';
import { ValidatorCheck } from '../../utils/validator.check';

@Component({
    selector: 'pim-input-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.sass'],
    standalone: false
})
export class InputComponent implements ControlValueAccessor, OnInit {
	@Input()
	id!: string;
	@Input()
	tabindex!: number;
	@Input()
	label: string = '';
	@Input()
	inputType: string = 'text';

	@Input()
	readonly: boolean = false;

	@Input()
	comma: boolean = false;

	required: boolean = false;

	private internalValue: any = '';
	private onChangeCallback: (_: any) => void = noop;
	control!: UntypedFormControl;

	constructor(private validatorCheck: ValidatorCheck, @Self() public ngControl: NgControl) {
		this.ngControl.valueAccessor = this;
	}

	ngOnInit(): void {
		this.control = this.ngControl.control as UntypedFormControl;
		this.required = this.validatorCheck.isRequired(this.control);
	}

	get fullLabel(): string {
		const requiredAstersik = this.required ? ' *' : '';
		return `${this.label}${requiredAstersik}`;
	}

	get value(): any {
		return this.internalValue;
	}

	set value(v: any) {
		if (v === this.internalValue) {
			return;
		}

		if (this.inputType === 'number') {
			if (v === '' || v === null || v === undefined) {
				this.internalValue = '';
			} else {
				this.internalValue = +v;
			}
		} else {
			this.internalValue = v?.toString() || v?.trim();
		}
		this.onChangeCallback(this.internalValue);
	}

	isNumber(event: any): boolean {
		if (this.inputType.toLowerCase() !== 'number') {
			return false;
		}

		const keycode = event.keyCode;
		return this.isNumberKeycode(keycode) || this.isCommaKeycode(keycode);
	}

	private isCommaKeycode(keycode: number): boolean {
		return keycode === 44;
	}

	private isNumberKeycode(keycode: number): boolean {
		return keycode >= 48 && keycode <= 57;
	}

	writeValue(obj: any): void {
		if (this.value !== obj) {
			this.value = obj;
		}
	}

	registerOnChange(fn: any): void {
		this.onChangeCallback = fn;
	}

	registerOnTouched(): void {
	}

}
